import type { ReactNode } from 'react';
import clsx from 'clsx';

import FiltersDisclosure from '~/shared/components/filters/FiltersDisclosure';

interface FilterCheckboxDisclosureProps {
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  onClear: () => void;
  children: ReactNode;
  className?: string;
}

export default function FilterCheckboxDisclosure({
  title,
  open,
  onOpenChange,
  selectedCount,
  onClear,
  children,
  className,
}: FilterCheckboxDisclosureProps) {
  return (
    <FiltersDisclosure
      title={title}
      count={selectedCount > 0 ? selectedCount : undefined}
      className={clsx('px-8 border-b border-gray-300', className)}
      open={open}
      onOpenChange={onOpenChange}
      onClearFilters={onClear}
    >
      {children}
    </FiltersDisclosure>
  );
}
